import styled from "styled-components";
import { modalZIndex } from "../../../utility";
import { tabletOrLargerDevices } from "../../../globalConstants";

export const CAROUSEL_SIZE_PX = 408;
const CAROUSEL_SIZE_COMPACT_PX = 343;
const MOBILE_PADDING_RIGHT_PERCENT = 3;

export const $InstanceDetails = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 22px 24px 24px;
  overflow: scroll;
  overflow-x: hidden;
  @media (max-width: ${tabletOrLargerDevices}) {
    overflow: unset;
  }
  .header {
    display: flex;
    position: sticky;
    top: 0;
    padding-right: 4px;
    padding-top: 24px;
    margin-bottom: 24px;
    background: white;
    z-index: ${modalZIndex};
    padding-bottom: 2px;
    svg {
      margin-left: auto;
      cursor: pointer;
    }
  }
  p.carousel-status, ul.control-dots, button.control-arrow {
    display: none;
  }
  .image-container {
    width: 100%;
    max-width: ${CAROUSEL_SIZE_PX}px;
    height: ${CAROUSEL_SIZE_PX}px;
    img {
      width: 100%;
      height: ${CAROUSEL_SIZE_PX}px;
      object-fit: contain;
    }
  }
  ul.thumbs {
    &, * {
      transform: none !important;
      transition-duration: 0s !important;
    }
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0;
    width: 100%;
    li {
      flex-shrink: 0;
      margin-bottom: 8px;
    }
    & > *:focus-visible {
      outline: 2px solid blue;
    }
  }

  /* Ensure carousel displays horizontally */
  .carousel .slider-wrapper.axis-horizontal .slider {
    display: flex;
    flex-direction: row;
  }

  .carousel .slider-wrapper {
    clip-path: inset(0);
  }

  li.slide {
    list-style: none;
    width: 100%;
    min-width: 100%;
    flex-shrink: 0; //stops slides shrinking below min-width when there are 2+
  }

  ul.slider {
    padding: 0;
    color: green;
    li.selected {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .carousel-slider {
    @media (max-width: ${tabletOrLargerDevices}) {
      width: 100% !important;
    }
  }
  div.thumbs-wrapper {
    overflow: unset;
    li, li.thumb.selected {
      height: 40px;
    }
    li, li.thumb, li.thumb.selected {
      width: 40px !important;
    }
    li.thumb {
      border: 1px solid #D8D8D8;
      border-radius: 4px;
      padding: 0;
      overflow: hidden;
    }
    li.thumb.selected {
       border: 2px solid #221F1F;
    }
    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }

  .purchase-header {
    margin: 4px 0 8px 0;
    .order-number {
      font-weight: 800;
      font-size: 14px;
      line-height: 20px;
      color: var(--text-black);
    }
    .order-date {
      font-size: 14px;
      line-height: 20px;
      color: var(--header-grey);
    }
  }

  .purchase-name, .purchase-brand {
    font-size: 15px;
    line-height: 22px;
  }

  .apart {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .col {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    line-height: 20px;
    color: var(--header-grey);
    margin-top: 8px;
  }
  .carousel-root {
    max-width: ${CAROUSEL_SIZE_PX}px;
    width: 100%;
    margin: 0 auto;
    @media (max-width: ${tabletOrLargerDevices}) {
      margin-left: ${MOBILE_PADDING_RIGHT_PERCENT / 2}%;
    }
    &:focus, &:focus-within {
      outline: 2px solid blue;
    }
  }
  @media (max-width: 768px) {
    padding: 0% ${MOBILE_PADDING_RIGHT_PERCENT}% 0% 0%;
    overflow-y: auto;
    .image-container {
      width: 100%;
      max-width: ${CAROUSEL_SIZE_COMPACT_PX}px;
      height: ${CAROUSEL_SIZE_COMPACT_PX}px;
      img {
        width: 100%;
        height: ${CAROUSEL_SIZE_COMPACT_PX}px;
        object-fit: contain;
      }
    }
  }
`;
